export function getAuthRedirectPath(to: unknown): string | null {
  const redirectPath = Array.isArray(to) ? to[0] : to;

  if (typeof redirectPath !== "string" || redirectPath === "") {
    return null;
  }

  if (!redirectPath.startsWith("/") || redirectPath.startsWith("//")) {
    return null;
  }

  return redirectPath;
}

export function getLoginPath(to: string): string {
  return "/login?to=" + encodeURIComponent(to);
}

export function withAuthRedirect(path: string, to: unknown): string {
  const redirectPath = getAuthRedirectPath(to);

  if (redirectPath === null) {
    return path;
  }

  return `${path}?to=${encodeURIComponent(redirectPath)}`;
}
